import React from "react";

const hideOnError = (e) => { e.currentTarget.style.display = 'none'; };

const AvatarPreview = ({ avatar, size, showBackgroundFull = false, moodOverride = null, filterClass = '' }) => {
  const dimensions = size === "lg" ? "w-32 h-32" : "w-12 h-12";
  const imageClass =
    size === "lg"
      ? "w-full h-full object-contain"
      : "w-full h-full object-cover scale-150 translate-y-5";

  // Apply mood override for expressions (display-only, doesn't affect saved avatar)
  const effectiveEyebrows = moodOverride?.eyebrows ?? avatar.eyebrows;
  const effectiveMouth = moodOverride?.mouth ?? avatar.mouth;

  // If showBackgroundFull is true, render background outside the avatar container
  if (showBackgroundFull) {
    return (
      <div className="relative w-full h-full">
        {/* Environment/Background - fills parent container */}
        {avatar.environment && (
          <img
            src={`/avatar-env-${avatar.environment}.png`}
            alt="Background"
            className="absolute inset-0 w-full h-full object-cover rounded-lg"
          />
        )}

        {/* Avatar in center */}
        <div className="relative flex items-center justify-center h-full">
          <div className={`${dimensions} relative overflow-hidden rounded-full ${filterClass}`}>
            {/* Base figure with skin color */}
            <img
              src={`/avatar-base-${avatar.skinColor}.png`}
              alt="Avatar"
              className={"absolute inset-0 " + imageClass}
            />

            {/* Bottom */}
            {avatar.bottom && (
              <img
                src={`/avatar-bottom-${avatar.bottom}.png`}
                alt="Bottom"
                className={"absolute inset-0 " + imageClass}
              />
            )}

            {/* Top */}
            {avatar.top && (
              <img
                src={`/avatar-top-${avatar.top}.png`}
                alt="Top"
                className={"absolute inset-0 " + imageClass}
              />
            )}

            {/* Eyebrows */}
            {effectiveEyebrows && (
              <img
                src={`/avatar-eyebrows-${effectiveEyebrows}.png`}
                alt="Eyebrows"
                className={"absolute inset-0 " + imageClass}
                onError={hideOnError}
              />
            )}

            {/* Mouth */}
            {effectiveMouth && (
              <img
                src={`/avatar-mouth-${effectiveMouth}.png`}
                alt="Mouth"
                className={"absolute inset-0 " + imageClass}
                onError={hideOnError}
              />
            )}

            {/* Hair */}
            {avatar.hair && (
              <img
                src={`/avatar-hair-${avatar.hair}.png`}
                alt="Hair"
                className={"absolute inset-0 " + imageClass}
              />
            )}

            {/* Beard */}
            {avatar.beard && (
              <img
                src={`/avatar-beard-${avatar.beard}.png`}
                alt="Beard"
                className={"absolute inset-0 " + imageClass}
              />
            )}

            {/* Glasses */}
            {avatar.glasses && (
              <img
                src={`/avatar-glasses-${avatar.glasses}.png`}
                alt="Glasses"
                className={"absolute inset-0 " + imageClass}
              />
            )}

            {/* Hat */}
            {avatar.hat && (
              <img
                src={`/avatar-hat-${avatar.hat}.png`}
                alt="Hat"
                className={"absolute inset-0 " + imageClass}
              />
            )}
          </div>
        </div>
      </div>
    );
  }

  // Original rendering - background inside rounded circle
  return (
    <div className={`${dimensions} relative overflow-hidden rounded-full ${filterClass}`}>
      {/* Environment/Background */}
      {avatar.environment && (
        <img
          src={`/avatar-env-${avatar.environment}.png`}
          alt="Background"
          className="absolute inset-0 w-full h-full object-cover"
        />
      )}

      {/* Base figure with skin color */}
      {/* Base figure with skin color */}
      <img
        src={`/avatar-base-${avatar.skinColor}.png`}
        alt="Avatar"
        className={"absolute inset-0 " + imageClass}
      />

      {/* Bottom */}
      {avatar.bottom && (
        <img
          src={`/avatar-bottom-${avatar.bottom}.png`}
          alt="Bottom"
          className={"absolute inset-0 " + imageClass}
        />
      )}

      {/* Top */}
      {avatar.top && (
        <img
          src={`/avatar-top-${avatar.top}.png`}
          alt="Top"
          className={"absolute inset-0 " + imageClass}
        />
      )}

      {/* Eyebrows */}
      {effectiveEyebrows && (
        <img
          src={`/avatar-eyebrows-${effectiveEyebrows}.png`}
          alt="Eyebrows"
          className={"absolute inset-0 " + imageClass}
          onError={hideOnError}
        />
      )}
      {/* Mouth */}
      {effectiveMouth && (
        <img
          src={`/avatar-mouth-${effectiveMouth}.png`}
          alt="Mouth"
          className={"absolute inset-0 " + imageClass}
          onError={hideOnError}
        />
      )}

      {/* Hair */}
      {avatar.hair && (
        <img
          src={`/avatar-hair-${avatar.hair}.png`}
          alt="Hair"
          className={"absolute inset-0 " + imageClass}
        />
      )}

      {/* Beard */}
      {avatar.beard && (
        <img
          src={`/avatar-beard-${avatar.beard}.png`}
          alt="Beard"
          className={"absolute inset-0 " + imageClass}
        />
      )}

      {/* Glasses */}
      {avatar.glasses && (
        <img
          src={`/avatar-glasses-${avatar.glasses}.png`}
          alt="Glasses"
          className={"absolute inset-0 " + imageClass}
        />
      )}

      {/* Hat */}
      {avatar.hat && (
        <img
          src={`/avatar-hat-${avatar.hat}.png`}
          alt="Hat"
          className={"absolute inset-0 " + imageClass}
        />
      )}
    </div>
  );
};

export default AvatarPreview;
